{
    "NAME": "Datenbanksprache",
    "Database_Section_MaintenanceInterval_Title": "Datenbankwartungsintervall",
    "Database_Section_MaintenanceInterval_Description": "Konfigurieren Sie einen täglichen Zeitraum, in dem die Anwendung die Datenbankaktivität unterbricht. Die Start- und Endzeitpunkte werden in UTC interpretiert.",
    "Database_Field_MaintenanceInterval_Enabled": "Datenbankaktivität täglich aussetzen",
    "Database_Field_MaintenanceInterval_TimeStart": "Startzeit (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "Endzeit (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Wochentage",
    "Database_Day_Monday": "Montag",
    "Database_Day_Tuesday": "Dienstag",
    "Database_Day_Wednesday": "Mittwoch",
    "Database_Day_Thursday": "Donnerstag",
    "Database_Day_Friday": "Freitag",
    "Database_Day_Saturday": "Samstag",
    "Database_Day_Sunday": "Sonntag",
    "Database_Action_Apply": "Anwenden",
    "Database_Action_Cancel": "Stornieren",
    "Database_Action_Refresh": "Aktualisieren",
    "Database_Save_Success": "Datenbankeinstellungen gespeichert.",
    "Database_Save_Error": "Datenbankeinstellungen konnten nicht gespeichert werden.",
    "Database_Load_Error": "Die Datenbankeinstellungen konnten nicht geladen werden.",
    "Database_Warning_ReadOnly": "Sie können diese Einstellungen zwar einsehen, aber nicht ändern. Nur Systemadministratoren mit Root-Zugriff können die Datenbankeinstellungen bearbeiten.",
    "Database_Warning_Unavailable": "Die Datenbankeinstellungen sind momentan nicht verfügbar. Möglicherweise war die Datenbank beim Start der Anwendung nicht zugänglich."
}